import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Col, Row } from "reactstrap";
import cx from "classnames";

import host from "assets/images/sbs/sbs_tot/host.png";
import dummyAvatar from "assets/images/sbs/dummyAvatar.png";
import totLogo from "assets/images/sbs/sbs_tot/logo_TOT.png";
import skipImg from "assets/images/sbs/sbs_tot/skip-img.png";
import scoreImg from "assets/images/sbs/sbs_tot/scoreImg.png";
import categoryImg from "assets/images/sbs/sbs_tot/category.png";
import guesserBox from "assets/images/sbs/sbs_tot/guesser-box.png";
import guessedCard from "assets/images/sbs/sbs_tot/guessed-box.png";
import skippedCard from "assets/images/sbs/sbs_tot/skipped-box.png";
import CircleTimer from "components/circleTimer";

const Guessing = ({ users, onTimesUp, totRightWords }) => {
  const [showSkip, setSkip] = useState(false);
  const [showScore, setScore] = useState(false);
  const [prevSkipWords, setPrevSkipWords] = useState(0);
  const [prevScoreWords, setPrevScoreWords] = useState(0);
  const [tot_countdown, set_tot_countdown] = useState(60);

  const guesserPlayerId = useSelector(
    (state) => state.gameReducer?.roomObj?.game_state?.active_player
  );
  const gameState = useSelector(
    (state) => state.gameReducer?.roomObj?.game_state
  );
  const gameName = useSelector((state) => state.gameReducer?.gameName);
  const guesserData = users.filter(
    (user) => guesserPlayerId === user.player_id
  );
  const skippedWords = gameState?.skipped_words;
  const rightWords = gameState?.right_words;

  useEffect(() => {
    let timer;
    if (tot_countdown > 0) {
      timer = setInterval(() => set_tot_countdown(tot_countdown - 1), 1000);
    } else if (tot_countdown === 0) {
      onTimesUp();
    }
    return () => clearInterval(timer);
  }, [tot_countdown]);

  useEffect(() => {
    if (skippedWords.length > prevSkipWords) {
      setSkip(true);
      setTimeout(() => {
        setSkip(false);
      }, 1500);
      setPrevSkipWords(skippedWords.length);
    }
    if (rightWords.length > prevScoreWords) {
      setScore(true);
      setTimeout(() => {
        setScore(false);
      }, 1500);
      setPrevScoreWords(rightWords.length);
    }
  }, [skippedWords, rightWords]);

  return (
    <div className="skip-screen-wrapper">
      <div className="total-score">
        <p className="txt">total score</p>
        <p className="score">{totRightWords.length}</p>
      </div>
      <Row>
        <Col lg={12} xl={12}>
          <img src={totLogo} className="sbs-tot-logo" alt="" />
        </Col>
      </Row>
      <Row>
        {showSkip && (
          <Col lg={8} xl={8}>
            <img src={skipImg} className="skipImg mt-2" alt="" />
          </Col>
        )}
        {showScore && (
          <Col lg={8} xl={8}>
            <img src={scoreImg} className="skipImg mt-2" alt="" />
          </Col>
        )}

        {!showSkip && !showScore && (
          <>
            <Col lg={4} xl={4} className="offset-1">
              <div className="guessedCard">
                <img src={guessedCard} className="guessedCardImg" alt="" />
                <div className="guessed-num">
                  <span>{gameState?.right_words.length}</span>
                </div>
                <div className="guessers">
                  <div className="guessers-list">
                    {gameState?.right_words &&
                      gameState?.right_words.length > 0 &&
                      gameState?.right_words?.map((item) => (
                        <div className="gue-name">
                          <p className="name">{item.word}</p>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            </Col>
            <Col lg={4} xl={4}>
              <div className="guessedCard">
                <img src={skippedCard} className="guessedCardImg" alt="" />
                <div className="skipped-num">
                  <span>{gameState?.skipped_words.length}</span>
                </div>
                <div className="skippers">
                  <div className="skippers-list">
                    {gameState?.skipped_words &&
                      gameState?.skipped_words.length > 0 &&
                      gameState?.skipped_words?.map((item) => (
                        <div className="ski-name">
                          <p className="name">{item.word}</p>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            </Col>
          </>
        )}
      </Row>
      <Row>
        <Col lg={4} xl={4} className="offset-1">
          <div className="skip-left-flex">
            <div className="skip-left">
              <div className="time-left">
                <p className="txt">Time Left</p>
                <p
                  className={cx("time", {
                    timeGreen: 40 < tot_countdown < 60,
                    timeOrange: 15 < tot_countdown < 40,
                    timeRed: 0 < tot_countdown < 15
                  })}
                >
                  {tot_countdown}
                </p>
              </div>
              <CircleTimer
                profImg={
                  guesserData[0]?.profile_image !== "profileImage"
                    ? guesserData[0]?.profile_image
                    : dummyAvatar
                }
                gameCode={gameName}
                tot
                count={(100 / 60) * tot_countdown}
                time={tot_countdown}
              />
            </div>
            <div className="guesser-box-category">
              <img src={guesserBox} alt="" />
              <p className="guesser">
                {guesserData[0]?.display_name.length > 15
                  ? guesserData[0]?.display_name.slice(0, 15) + "..."
                  : guesserData[0]?.display_name}
              </p>
            </div>
          </div>
        </Col>
        <Col lg={4} xl={4}>
          <div className="tot-category">
            <div className="tot-category-box">
              <img src={categoryImg} className="img-fluid" alt="" />
              <p className="name">{gameState?.current_category}</p>
              <img
                src={gameState?.category_image}
                className="img-fluid img"
                alt=""
              />
            </div>
          </div>
        </Col>

        <Col lg={3} xl={3}>
          <div className="host-img-category">
            <img src={host} className="img" alt="" />
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default Guessing;
